/**
 * Configuration object for responsive column counts.
 * Each breakpoint maps to its column count.
 */

/**
 * Represents the current state of breakpoints.
 * Used to determine which column count to use.
 */

/** Estimated height (in pixels) of a single card/item. */
export const ESTIMATE_HEIGHT_CARD = 331;

/** Number of extra rows to render above and below the visible viewport for virtualization. */
export const CARDS_IN_DOM_UP_AND_DOWN = 5;

/** Default column configuration for all breakpoints. */
export const DEFAULT_COLUMN_CONFIG = {
  xxxl: 5,
  xxl: 5,
  xl: 5,
  lg: 4,
  md: 3,
  sm: 1,
  xs: 1
};

/** Returns the number of columns to use based on the given breakpoint state */
export function getColumnCountFromConfig(config, bp) {
  if (bp.isScreenXXXL) {
    return config.xxxl;
  }
  if (bp.isScreenXXL) {
    return config.xxl;
  }
  if (bp.isXL) {
    return config.xl;
  }
  if (bp.isLG) {
    return config.lg;
  }
  if (bp.isMD) {
    return config.md;
  }
  if (bp.isSM) {
    return config.sm;
  }
  return config.xs;
}

/** Space between the columns of a grid with more than one column, in pixels */
export const GRID_COLUMN_GAP = 16;

/**
 * Card grids (projects, groups): the most cards a row holds per breakpoint. Six only from XL up,
 * and only as many as fit at `CARD_MIN_COLUMN_WIDTH`, e.g. fewer while the sidebar is expanded.
 */
export const CARD_COLUMN_CONFIG = {
  xxxl: 6,
  xxl: 6,
  xl: 6,
  lg: 5,
  md: 4,
  sm: 1,
  xs: 1
};

/**
 * Narrowest a card may get, in pixels, so its content keeps room to breathe. Six cards need a
 * 1340px wide grid: an XL screen with the sidebar collapsed, or about 1680px with it expanded.
 */
export const CARD_MIN_COLUMN_WIDTH = 210;

/** Returns how many columns of at least `minColumnWidth` fit in `gridWidth`, from 1 to `maxColumnCount` */
export function getColumnCountFromWidth({
  gridWidth,
  minColumnWidth,
  maxColumnCount
}) {
  const fittingColumns = Math.floor((gridWidth + GRID_COLUMN_GAP) / (minColumnWidth + GRID_COLUMN_GAP));
  return Math.min(maxColumnCount, Math.max(1, fittingColumns));
}